import { render, staticRenderFns } from "./page_new_ap.vue?vue&type=template&id=b7c4bba2&scoped=true&"
import script from "./page_new_ap.vue?vue&type=script&lang=js&"
export * from "./page_new_ap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c4bba2",
  null
  
)

export default component.exports